<template>
    <div class="modal fade" :id="name" >
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Anexo</h4>
                    <button type="button" class="close" @click="close">&times;</button>
                </div>

                <div class="modal-body">
                    <alert ref="alert" />

                     <div class="row">
                        <div class="col-12">
                            <div class="input-group mb-3 input-group-sm">
                                <input type="text" class="form-control" placeholder="Protocolo" @keyup.enter="save" v-model="attachment.nome">
                                
                                <div class="input-group-append">
                                    <button class="btn btn-primary" @click="audio_arquivo(attachment)">Download</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-sm-flex justify-content-center">
                        <img :src="attachment.file" width="100%" v-if="type === 'image'" />
                        <video v-if=" type === 'video'" width="100%" :src="attachment.file" controls></video>
                    </div>

                    <player :audio_hash="attachment.file" name="anexo-player" :class="( type != 'audio' ) ? 'hidden' : ''" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import player from "@/components/Tools/Player"
    import alert  from '@/components/Tools/alert'
    import api    from '@/mixins/api.js'

    export default {
        name: "modal-anexo",
        props: [ 'attachment', 'name' ],
        components: { player, alert },
        mixins: [ api ],

        computed: {
            type() {
                return (this.attachment.type) ? this.attachment.type.split('/')[0] : null
            }
        },

        methods: {
            async save() {
                const response = await this.PUT('Denuncia/Anexo', this.attachment)
                const message  = (response.status === 'success') ? 'Dados atualizados com sucesso.' : 'Erro ao atualizar dados.'
                this.$refs.alert.alert(message, 'alert-info')
            },

            audio_arquivo(payload){
				var respota = payload.file
				var nome_audio = payload.nome
				var fileURL=window.URL.createObjectURL(new Blob([respota]));
				var fileLink=document.createElement('a');
				fileLink.href=respota;
				fileLink.setAttribute('download', nome_audio);
				document.body.appendChild(fileLink);
				fileLink.click();
			},

            close() {
                $(`#${this.name}`).modal('hide')
            }
        }
    }
</script>

<style>

</style>